tr.mappingTableRow {
  border-bottom: none !important;
}
tr.mappingTableRowDisabled {
  color: var(--mantine-spacing-sm-gray-80);
}
